var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"QuestionnaireSet"},[_c('a-card',{staticClass:"card",attrs:{"title":"基本设置","bordered":false}},[_c('BaseSet',{ref:"BaseSet",on:{"changeType":_vm.changeType}})],1),(_vm.type == 'edit')?_c('a-card',{staticClass:"card",staticStyle:{"margin-top":"20px"},attrs:{"title":"能力设置","bordered":false}},[_c('AblitySet')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }